import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

export const useJoinTrip = () => {
	const queryClient = useQueryClient()

	return useMutation<Trip, Error, string>({
		mutationFn: async (code: string) => {
			const response = await api.post<Trip>(`/trips/${code}/join`)
			return response.data
		},
		onSuccess: () => {
			// Invalidate and refetch trips list
			queryClient.invalidateQueries({ queryKey: queryKeys.trips() })
		},
	})
}

